import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { useFacilityProfile } from "@src/appV2/Facilities/api/useFacilityProfile";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  SystemInlineBanner,
  Text,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

import { Button } from "../../components/Button";
import { DialogFooter } from "../../components/DialogFooter";
import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";

interface VisitLoggedBottomSheetProps {
  modalState: UseModalState;
}

export function VisitLoggedBottomSheet(props: VisitLoggedBottomSheetProps) {
  const { modalState } = props;
  const { case: caseData } = useInHomeVisitModalsDataContext();
  const { data: facility } = useFacilityProfile(
    { workplaceId: caseData?.attributes.workplaceId ?? "" },
    {
      enabled: isDefined(caseData?.attributes.workplaceId),
    }
  );

  const agencyName = facility?.name ?? "The agency";

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth variant="contained" onClick={modalState.closeModal}>
            Got it
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        hasFooter
        illustrationType="shift-booked"
        title="Your visit has been logged"
        description={
          <Stack spacing={4} sx={{ width: "100%" }}>
            <Text variant="body2">
              After {agencyName} has verified your visit, you&apos;ll be instantly paid.
            </Text>

            <SystemInlineBanner color="warning" iconType="document" sx={{ textAlign: "left" }}>
              <Stack spacing={2}>
                <Text bold variant="body2">
                  Time to complete your documentation notes!
                </Text>
                <Text variant="body2">
                  In order to receive your pay, please complete your notes within <b>24 hours</b> of
                  this visit. <b>Missing this window</b> may restrict your ability to accept new
                  visits until notes are submitted.
                </Text>
              </Stack>
            </SystemInlineBanner>
          </Stack>
        }
      />
    </BottomSheet>
  );
}
